<template>
    <!-- Cabeçalho -->
    <section class="cardapio-digital-busca-produto">
        <div class="cardapio-digital-busca-produto-filtro control has-icons-right">
            <input
                type="text"
                class="input form-control"
                id="cardapio-digital-busca-produto-filtro-input"
                placeholder="O que você procura?"
                v-model="termoFiltro"
                v-on:keyup="aplicarBuscaSensivel"
            />
            <span class="icon is-small is-right">
                <i class="fa-solid fa-magnifying-glass"></i>
            </span>
        </div>
        <div class="cardapio-digital-busca-produto-tipo-exibicao">
            <!-- <i class="fas fa-grip-vertical"></i> -->
            <i :class="layoutGrid ? 'fas fa-grip-vertical' : 'fas fa-list'" @click="alternarVisualizacao"></i>
        </div>
    </section>
</template>

<script>

import { debounce } from 'lodash'

const DEBOUNCE_SEARCH = 800;

export default {
    name: 'BuscaProduto',
    props: ["layoutGrid"],
    data() {
        return {
            termoFiltro: ''
        }
    },
    methods: {
        alternarVisualizacao() {
            this.$emit('alternarVisualizacao');
        },

        aplicarBuscaSensivel: debounce(function () {
            this.$emit('aplicarFiltro', this.termoFiltro);
        }, DEBOUNCE_SEARCH)
    }
}
</script>

<style scoped>
    .cardapio-digital-busca-produto {
        display: flex;
        align-items: center;
        flex-direction: row;
        width: 100%;
        justify-content: center;
        min-height: 2.7rem;
        margin-bottom: 1rem;
    }

    .cardapio-digital-busca-produto-filtro{
        width: 100%;
    }

    .cardapio-digital-busca-produto-filtro input{
        background-color: #EEEEEE;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); 
        border-radius: 30px;
    }

    .cardapio-digital-busca-produto-tipo-exibicao {
        font-size: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 14px;
    }

    .cardapio-digital-busca-produto-tipo-exibicao i {
        width: 36px;
        font-size: 2.2rem;
        cursor: pointer;
    }
</style>